import { useGetFormValidationError } from "@tm/localization"
import { z } from "zod"

export function useProfileSchema() {
    const getError = useGetFormValidationError()
    return z.object({
        firstName: z.string().min(1, getError("REQUIRED")),
        lastName: z.string().min(1, getError("REQUIRED")),
    })
}

export function useEmailSchema() {
    const getError = useGetFormValidationError()
    return z.object({
        email: z.string().min(1, getError("REQUIRED")).email(getError("INVALID_EMAIL")),
    })
}

export type ProfileFormValues = z.infer<ReturnType<typeof useProfileSchema>>
export type EmailFormValues = z.infer<ReturnType<typeof useEmailSchema>>
